import pkg from '../../package.json';
export default () => pkg.version;
//# sourceMappingURL=getPackageVersion.js.map